<template>
    <!-- Integração SED: aluno com matrícula ativa em escola de fora da rede. A escola de destino inscreve o aluno
         (Inscrição de Transferência) e depois conclui a matrícula; a SED encerra a matrícula da origem sozinha. -->
    <el-dialog title="Inscrição de transferência (SED)" :visible="visible" @update:visible="fechar" @open="carregar" width="70%" append-to-body :close-on-click-modal="false">

        <div v-loading="carregando" style="min-height: 60px;">

            <template v-if="opcoes">

                <el-alert v-if="opcoes.matricula_atual" type="warning" :closable="false" show-icon class="u-mb-15 u-mt-20"
                    :title="'O aluno tem matrícula ativa em ' + opcoes.matricula_atual.escola">
                    {{ opcoes.matricula_atual.municipio }} · {{ opcoes.matricula_atual.rede }} — {{ opcoes.matricula_atual.desc_serie }} {{ opcoes.matricula_atual.turma }}
                    ({{ opcoes.matricula_atual.turno }}), desde {{ opcoes.matricula_atual.inicio }}.
                </el-alert>

                <p class="u-mb-15" style="color: #606266;">
                    Para matriculá-lo em <b>{{ opcoes.destino.escola }}</b>, a SED exige antes a inscrição de transferência. A escola de origem não precisa fazer nada:
                    a matrícula de lá é encerrada pela SED quando esta matrícula for concluída.
                </p>

                <el-alert v-if="!opcoes.elegivel" type="error" :closable="false" show-icon :title="opcoes.motivo_inelegivel"></el-alert>

                <!-- Já inscrito: só falta concluir a matrícula (ou cancelar a inscrição) -->
                <template v-else-if="opcoes.inscricao_aberta">
                    <el-alert type="success" :closable="false" show-icon
                        :title="'Inscrição em aberto desde ' + opcoes.inscricao_aberta.data + ' (' + opcoes.inscricao_aberta.descricao + ')'">
                        Feche esta janela e clique em <b>CONCLUIR MATRÍCULA</b>.
                    </el-alert>
                </template>

                <el-form v-else ref="form" :model="form" label-position="top" @submit.native.prevent="inscrever">
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="12" :md="12">
                            <el-form-item label="Tipo de movimentação" prop="fase" :rules="[$requiredChange]">
                                <el-select v-model="form.fase" @change="form.motivo = ''">
                                    <el-option v-for="f in opcoes.fases" :key="f.codigo" :label="f.nome" :value="f.codigo"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="12">
                            <el-form-item label="Motivo" prop="motivo" :rules="[$requiredChange]">
                                <el-select v-model="form.motivo" :disabled="!form.fase">
                                    <el-option v-for="(nome, codigo) in motivos" :key="codigo" :label="nome" :value="codigo"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-form-item>
                        <el-checkbox v-model="form.interesse_integral">Interesse pelo turno integral</el-checkbox>
                    </el-form-item>

                    <!-- Mudança de residência: a SED recebe o endereço do cadastro do aluno -->
                    <el-alert v-if="pedeEndereco && !opcoes.endereco.completo" type="warning" :closable="false" show-icon
                        title="Endereço do aluno incompleto">
                        Para transferência por mudança de residência a SED exige o endereço completo. Falta: {{ opcoes.endereco.faltando.join(', ') }}. Complete o cadastro do aluno.
                    </el-alert>
                    <p v-else-if="pedeEndereco" class="u-mt-10" style="color: #909399;">O endereço do cadastro do aluno será enviado à SED.</p>
                </el-form>

            </template>
        </div>

        <span slot="footer" class="dialog-footer">
            <el-button @click="fechar(false)">Voltar</el-button>
            <el-button v-if="opcoes && opcoes.inscricao_aberta" type="danger" plain :loading="enviando" @click="cancelar">Cancelar inscrição</el-button>
            <el-button v-if="opcoes && opcoes.elegivel && !opcoes.inscricao_aberta" type="primary" :loading="enviando" :disabled="pedeEndereco && !opcoes.endereco.completo" @click="inscrever">Inscrever</el-button>
        </span>
    </el-dialog>
</template>
<script>
import { mostrarThrow as mostrarThrowSed } from '@/shared/sed'

export default {
    props: ['visible', 'pedido'],
    data: () => ({
        carregando: false,
        enviando: false,
        opcoes: null,
        form: { fase: '', motivo: '', interesse_integral: false }
    }),
    computed: {
        motivos() {
            return this.opcoes && this.form.fase ? (this.opcoes.motivos[this.form.fase] || {}) : {};
        },
        pedeEndereco() {
            return this.form.fase === '0' && this.form.motivo === '1';
        },
        url() {
            return `${this.$store.state.config.baseUrlApi}/api/sed/aluno/inscricao-transferencia`;
        },
        base() {
            return { aluno_id: this.pedido.aluno_id, turma_id: this.pedido.turma_id, referencia_nacional: this.pedido.referencia_nacional };
        }
    },
    methods: {
        fechar(inscrito) {
            this.$emit('update:visible', false);
            if (inscrito === true) this.$emit('inscrito');
        },
        carregar() {
            this.opcoes = null;
            this.form = { fase: '', motivo: '', interesse_integral: false };

            if (!this.pedido) return;

            this.carregando = true;

            this.$axios.post(this.url + '/opcoes', this.base, this.$store.getters.getHeaderAuth).then(response => {

                this.carregando = false;

                if (mostrarThrowSed(this, response.data)) { this.fechar(false); return; }

                this.opcoes = response.data;

            }).catch((error) => { this.carregando = false; this.$store.commit('throwException', error); });
        },
        inscrever() {
            this.$refs.form.validate(ok => {
                if (!ok) return;

                this.enviando = true;

                this.$axios.post(this.url, Object.assign({}, this.base, this.form), this.$store.getters.getHeaderAuth).then(response => {

                    this.enviando = false;

                    if (mostrarThrowSed(this, response.data)) return;

                    window.eventBus.$emit('alert', { msg: response.data.success, type: 'success' });
                    this.fechar(true);

                }).catch((error) => { this.enviando = false; this.$store.commit('throwException', error); });
            });
        },
        cancelar() {
            this.$confirm('Cancelar a inscrição de transferência deste aluno na SED?', 'Atenção', { confirmButtonText: 'Sim, cancelar', cancelButtonText: 'Não', type: 'warning' }).then(() => {

                this.enviando = true;

                this.$axios.post(this.url + '/cancelar', this.base, this.$store.getters.getHeaderAuth).then(response => {

                    this.enviando = false;

                    if (mostrarThrowSed(this, response.data)) return;

                    window.eventBus.$emit('alert', { msg: response.data.success, type: 'success' });
                    this.carregar();

                }).catch((error) => { this.enviando = false; this.$store.commit('throwException', error); });

            }).catch(() => {});
        }
    }
}
</script>
